import React from 'react';
import { Genre, genreLabels, Language } from '../types';

interface GenreSelectorProps {
  selectedGenre: Genre | null;
  onSelect: (genre: Genre) => void;
  isLoading: boolean;
  language: Language;
}

const GenreSelector: React.FC<GenreSelectorProps> = ({ selectedGenre, onSelect, isLoading, language }) => {
  const title = language === 'fa' 
    ? 'ژانر مورد علاقه خود را انتخاب کنید' 
    : 'Select your favorite genre';

  return (
    <div className="w-full max-w-4xl mx-auto">
      <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4 text-center">
        {title}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {(Object.keys(Genre) as Array<keyof typeof Genre>).map((key) => {
          const genreValue = Genre[key];
          const isSelected = selectedGenre === genreValue;
          
          return (
            <button
              key={genreValue}
              onClick={() => onSelect(genreValue)}
              disabled={isLoading}
              className={`
                relative px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 border
                ${isSelected 
                  ? 'bg-indigo-600 text-white border-indigo-600 shadow-lg scale-105' 
                  : 'bg-white dark:bg-slate-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-slate-700 hover:border-indigo-300 hover:bg-indigo-50 dark:hover:bg-slate-700'}
                ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}
              `}
            >
              {genreLabels[genreValue][language]}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GenreSelector;